import React, { Component } from "react";
import ErrorSprite from '../assets/Error.svg';
import Button from "../components/Button";
import Title from "../components/Title";

class AuthError extends Component {
  render() {
    //const { message } = this.props
    return (
      <React.Fragment>
        <Title text={'Código incorreto!'} />
        <img src={ErrorSprite} className='hc-icon'/>
        <Button label="Enviar Novamente" onClick={this.props.onResetClick}/>
      </React.Fragment>
    );
  }
}

export default AuthError;
